
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiOwnShipNoCommandC as ObiOwnShipNoCommandCElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-own-ship-no-command-c.js';
 
 
 

 
 export const ObiOwnShipNoCommandC = createComponent({
   react: React,
   tagName: 'obi-own-ship-no-command-c',
   elementClass: ObiOwnShipNoCommandCElement,
   events: {
     
   }
  });
 
 